export default {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID, // Your user pool id here
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID, // Your client id here
};
